import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional } from "@/__main__/data-model.mjs";

export const fortniteSeasonModel = {
  archivedAt: Optional(Date),
  endAt: Optional(Date),
  id: String,
  startAt: Date,
  name: String,
} satisfies ModelDefinition;

export const FortniteSeasonsModel = createModel({
  data: { seasons: [fortniteSeasonModel] },
}).transform([fortniteSeasonModel], (data) =>
  data.data.seasons
    .filter((d) => !d.archivedAt)
    .filter((d) => new Date(d.startAt).getTime() < Date.now())
    .sort(
      (a, b) =>
        new Date(b?.startAt ?? Date.now())?.getTime() -
        new Date(a?.startAt ?? Date.now())?.getTime(),
    ),
);

export type FortniteSeasons = FromModel<typeof FortniteSeasonsModel>;

export default FortniteSeasonsModel;
